import React from 'react';
import { useParams } from 'react-router-dom';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { LandingHeader } from '../components/LandingHeader';
import { blogPosts, findPost, formatPostDate } from '../data/blogPosts';
import { useScreenInit } from '../useScreenInit';
export function BlogPostPage() {
  const params = useParams<{
    slug?: string;
  }>();
  const screenInit = useScreenInit() as {
    slug?: string;
  };
  const slug = params.slug || screenInit.slug || blogPosts[0].slug;
  const post = findPost(slug) || blogPosts[0];
  const related = blogPosts.filter(entry => entry.slug !== post.slug).slice(0, 3);
  return <div id="top" className="min-h-screen w-full bg-white text-[#041F60]" data-id="element-602" data-mp="17god8t5sh0u0">
      <a href="#main-content" className="sr-only fixed left-4 top-4 z-50 rounded-lg bg-[#041F60] px-4 py-2 text-sm font-bold text-white focus:not-sr-only focus:outline-none focus:ring-2 focus:ring-[#4BE4FF]" data-id="element-603" data-mp="1cf94w46z6c6u">
        Skip to content
      </a>
      <LandingHeader current="/blog" data-id="element-604" data-mp="kb4pze7fm9my" />

      <main id="main-content" data-id="element-605" data-mp="kc7g3jwxk81t">
        <article data-id="element-606" data-mp="k9bixxswpnef">
          <header className="border-b border-[#A6B6F8]/50 bg-[#A6B6F8]/20" data-id="element-607" data-mp="g9syf34zzec4">
            <div className="mx-auto max-w-3xl px-5 py-12 sm:px-8 sm:py-16" data-id="element-608" data-mp="g7pxho2b40sm">
              <a href="/blog" className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#5B5299] transition hover:text-[#041F60] focus:underline focus:outline-none" data-id="element-609" data-mp="u2sb6xdeaufz">
                <ArrowLeftIcon size={15} aria-hidden="true" data-id="element-610" data-mp="141hrilpn86u4" /> All articles
              </a>
              <p className="mt-7 text-xs font-bold uppercase tracking-[0.16em] text-[#5B5299]" data-id="element-611" data-mp="z2ep7911sepu">
                {post.category}
              </p>
              <h1 className="mt-3 text-3xl font-bold tracking-[-0.04em] sm:text-[2.75rem] sm:leading-[1.08]" data-id="element-612" data-mp="180gtpyjzpphv">
                {post.title}
              </h1>
              <p className="mt-5 text-lg leading-8 text-[#3A3A3A]" data-id="element-613" data-mp="3etj3tmmi1gu3">
                {post.standfirst}
              </p>
              <div className="mt-7 flex flex-wrap items-center gap-x-3 gap-y-1 border-t border-[#A6B6F8]/60 pt-5 text-sm text-stone-600" data-id="element-614" data-mp="1dp75sb8zg7ez">
                <span className="font-semibold text-[#041F60]" data-id="element-615" data-mp="1ipd1c2idie2c">
                  {post.author}
                </span>
                <span aria-hidden="true" data-id="element-616" data-mp="1nltpgwpkosff">·</span>
                <time dateTime={post.date} data-id="element-617" data-mp="1roq7al7agkib">{formatPostDate(post.date)}</time>
                <span aria-hidden="true" data-id="element-618" data-mp="1rmnclnv6y379">·</span>
                <span data-id="element-619" data-mp="1wn1mlbgcrn7x">{post.readingMinutes} min read</span>
              </div>
            </div>
          </header>

          <div className="mx-auto max-w-3xl px-5 py-14 sm:px-8 sm:py-16" data-id="element-620" data-mp="21ll6l6bdyoxn">
            {post.body.map(section => <section key={section.heading} className="mt-12 first:mt-0" data-id="element-621" data-mp="26fz69kx2zi84">
                <h2 className="text-xl font-bold tracking-tight sm:text-2xl" data-id="element-622" data-mp="2bbo15ay5oay3">
                  {section.heading}
                </h2>
                {section.paragraphs.map(paragraph => <p key={paragraph} className="mt-4 text-base leading-8 text-[#3A3A3A]" data-id="element-623" data-mp="2kefe5f6ojeru">
                    {paragraph}
                  </p>)}
                {section.bullets && <ul className="mt-5 space-y-3 border-l-2 border-[#4BE4FF] pl-5" data-id="element-624" data-mp="3vuqafyuhb6io">
                    {section.bullets.map(bullet => <li key={bullet} className="text-base leading-7 text-[#3A3A3A]" data-id="element-625" data-mp="3qx8agxyfw1mt">
                        {bullet}
                      </li>)}
                  </ul>}
              </section>)}
          </div>
        </article>

        <section className="border-t border-[#A6B6F8]/50 bg-white" data-id="element-626" data-mp="dpet8og7rt84">
          <div className="mx-auto max-w-6xl px-5 py-14 sm:px-8 sm:py-16" data-id="element-627" data-mp="dp51owfite0b">
            <h2 className="text-sm font-bold uppercase tracking-[0.16em] text-[#5B5299]" data-id="element-628" data-mp="1b5kgnbeq2p88">
              Read next
            </h2>
            <ul className="mt-8 grid gap-5 md:grid-cols-3" data-id="element-629" data-mp="16bzhhg1e7p7g">
              {related.map(entry => <li key={entry.slug} className="h-full" data-id="element-630" data-mp="q0wagfpcdjrr">
                  <article className="flex h-full flex-col rounded-2xl border border-[#A6B6F8]/50 bg-white p-6" data-id="element-631" data-mp="uyphtc2dsjtm">
                    <p className="text-xs font-bold uppercase tracking-[0.12em] text-[#5B5299]" data-id="element-632" data-mp="gzg0g92fvjo2">
                      {entry.category}
                    </p>
                    <h3 className="mt-3 text-lg font-bold leading-snug tracking-tight" data-id="element-633" data-mp="19m0rf8f05tr3">
                      <a href={`/blog/${entry.slug}`} className="underline-offset-4 hover:underline focus:underline focus:outline-none" data-id="element-634" data-mp="1dnw0iz36dbff">
                        {entry.title}
                      </a>
                    </h3>
                    <p className="mt-3 text-sm leading-6 text-[#3A3A3A]" data-id="element-635" data-mp="1slogfscmw1u5">
                      {entry.excerpt}
                    </p>
                    <p className="mt-auto pt-6 text-xs font-semibold text-stone-500" data-id="element-636" data-mp="1xd6di5bjdi9u">
                      {formatPostDate(entry.date)} · {entry.readingMinutes} min
                      read
                    </p>
                  </article>
                </li>)}
            </ul>
          </div>
        </section>

        <section className="navy-texture border-t border-[#031849] text-white" data-id="element-637" data-mp="2gfymb7dcu999">
          <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-8 px-5 py-14 sm:px-8 sm:py-20 md:flex-row md:items-center" data-id="element-638" data-mp="2bi6sg7t5gd2f">
            <div className="max-w-xl" data-id="element-639" data-mp="1jqqujhm573ww">
              <h2 className="text-3xl font-bold tracking-[-0.035em] sm:text-4xl" data-id="element-640" data-mp="1jrsigmo9bkw1">
                Put this into practice.
              </h2>
              <p className="mt-3 text-base leading-7 text-[#A6B6F8]" data-id="element-641" data-mp="1xnw07ghy20rm">
                Start your free trial and bring credit, collections and invoice
                finance into one practical view.
              </p>
            </div>
            <a href="/signup" className="inline-flex shrink-0 items-center gap-2 rounded-lg bg-[#4BE4FF] px-5 py-3.5 text-sm font-bold text-[#041F60] transition hover:bg-[#38d9f2] focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#041F60]" data-id="element-642" data-mp="3473xh98codd8">
              Start your free trial{' '}
              <ArrowRightIcon size={17} aria-hidden="true" data-id="element-643" data-mp="3l5vq2jeqf06f" />
            </a>
          </div>
        </section>
      </main>

      <footer className="bg-white" data-id="element-644" data-mp="2sjaypiy9ao2v">
        <div className="mx-auto flex max-w-6xl flex-col gap-5 px-5 py-8 sm:flex-row sm:items-center sm:justify-between sm:px-8" data-id="element-645" data-mp="2skc87izmj2ih">
          <p className="text-sm font-semibold text-[#041F60]" data-id="element-646" data-mp="2xg1e0428lfn8">Credit Manager</p>
          <a href="mailto:support@creditmanager.co.uk" className="text-sm font-semibold text-[#5B5299] underline decoration-[#A6B6F8] underline-offset-4 transition hover:text-[#041F60] focus:text-[#041F60] focus:outline-none" data-id="element-647" data-mp="32fmeiix21w22">
            Contact support
          </a>
          <p className="text-xs text-stone-500" data-id="element-648" data-mp="2eps0vz4ww3gr">© 2026 Credit Manager</p>
        </div>
      </footer>
    </div>;
}